import * as React from "react";
import { forwardRef } from "react";
const SvgIconTopic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 5.90002H13V8.90002H16V10.9H13V13.9H11V10.9H8V8.90002H11V5.90002Z", fill: "#0A7DA4" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2ZM5.2 16H20V4H4V17.2L5.2 16Z", fill: "#0A7DA4" }));
const ForwardRef = forwardRef(SvgIconTopic);
export default ForwardRef;
